import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";
import "katex/dist/katex.min.css";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";
import CrossBar from "../components/CrossBar.js";

import { concreteShear } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function ConcreteShear({}) {
  const toast = useToast();
  // SHEAR
  const [shearInputs, setShearInputs] = useState({
    fck: 20,
    fyk: 500,
    b: "",
    h: "",
    dl: "",
    vsd: "",
    model: "I",
    teta: 45,
    stress_type: "Flexão simples/Flexo-tração (LN corta a seção)",
    m0: "",
    msd_max: "",
  });
  const [shearOutputs, setShearOutputs] = useState({
    vrd2: "",
    vc: "",
    vsw: "",
    asw: "",
    asw_min: "",
    vsw_min: "",
    memorial: {},
  });

  function updateShearInputs(name, value) {
    if (name === "stress_type" || name === "model") {
      setShearInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
      if (name === "model" && value === "I") {
        setShearInputs((prevInputs) => ({
          ...prevInputs,
          teta: 45,
        }));
      }
      if (name === "model" && value === "II") {
        setShearInputs((prevInputs) => ({
          ...prevInputs,
          teta: "",
        }));
      }
    } else if (value === "") {
      setShearInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setShearInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setShearOutputs({
      vrd2: "",
      vc: "",
      vsw: "",
      asw: "",
      asw_min: "",
      vsw_min: "",
      memorial: {},
    });
  }

  function onShearCalculate() {
    if (
      shearInputs["b"] === "" ||
      shearInputs["h"] === "" ||
      shearInputs["dl"] === "" ||
      shearInputs["vsd"] === "" ||
      shearInputs["teta"] === "" ||
      (shearInputs["stress_type"] === "Flexo-compressão" &&
        (shearInputs["m0"] === "" || shearInputs["msd_max"] === ""))
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      shearInputs["b"] === 0 ||
      shearInputs["h"] === 0 ||
      shearInputs["dl"] === 0 ||
      shearInputs["vsd"] === 0 ||
      shearInputs["teta"] === 0 ||
      (shearInputs["stress_type"] === "Flexo-compressão" &&
        shearInputs["msd_max"] === 0)
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else if (
      shearInputs["model"] === "II" &&
      (shearInputs["teta"] < 30 || shearInputs["teta"] > 45)
    ) {
      toast({
        title: "O ângulo teta deve possui um valor entre 30º e 45º",
        status: "warning",
        isClosable: true,
      });
    } else {
      concreteShear(shearInputs).then((response) => {
        setShearOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "concrete-shear-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "concrete-shear-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Cisalhamento:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Seção"
              elements={["Retangular"]}
              unit=""
              // onChange={(e) => updateBendingInputs("fck", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="fck"
              elements={[
                20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
              ]}
              unit="MPa"
              onChange={(e) => updateShearInputs("fck", e.target.value)}
            />
            <Select
              text="fyk"
              elements={[500, 600]}
              unit="MPa"
              onChange={(e) => updateShearInputs("fyk", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateShearInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateShearInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="dl"
              unit="cm"
              onChange={(e) => updateShearInputs("dl", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Vsd"
              unit="tf"
              onChange={(e) => updateShearInputs("vsd", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Modelo"
              elements={["I", "II"]}
              unit=""
              onChange={(e) => updateShearInputs("model", e.target.value)}
            />
            {shearInputs["model"] === "I" ? (
              <h4 className={styles.rowDescription}>θ=45º</h4>
            ) : (
              <InputNumber
                text="θ"
                unit="º"
                onChange={(e) => updateShearInputs("teta", e.target.value)}
              />
            )}
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Caso"
              elements={[
                "Flexão simples/Flexo-tração (LN corta a seção)",
                "Elementos tracionados (LN fora da seção)",
                "Flexo-compressão",
              ]}
              unit=""
              onChange={(e) => updateShearInputs("stress_type", e.target.value)}
            />
          </div>
          {shearInputs["stress_type"] === "Flexo-compressão" && (
            <div className={styles.inputRow}>
              <InputNumber
                text="M0"
                unit=""
                onChange={(e) => updateShearInputs("m0", e.target.value)}
              />
              <InputNumber
                text="Msd,máx"
                unit=""
                onChange={(e) => updateShearInputs("msd_max", e.target.value)}
              />
            </div>
          )}
        </div>
        <div className={styles.buttons}>
          <button className={styles.calculateButton} onClick={onShearCalculate}>
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <Output text="Vrd2" value={shearOutputs["vrd2"]} unit="kN" />
          <Output text="Vc" value={shearOutputs["vc"]} unit="kN" />
          <Output text="Vsw" value={shearOutputs["vsw"]} unit="kN" />
          <Output text="Asw" value={shearOutputs["asw"]} unit="cm²/m" />
          <Output text="Asw,mín" value={shearOutputs["asw_min"]} unit="cm²/m" />
          <Output text="Vsw,mín" value={shearOutputs["vsw_min"]} unit="kN" />
          <CrossBar fyk={shearInputs["fyk"]} />
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {shearOutputs["memorial"] &&
          Object.entries(shearOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default ConcreteShear;
